import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 21h-5v-5h-5v-5h-5v-5h-5","key":"svg-0"}],["path",{"d":"M18 3v7","key":"svg-1"}],["path",{"d":"M15 7l3 3l3 -3","key":"svg-2"}]]

/**
 * IconStairsDown
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3RhaXJzLWRvd24iCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTIyIDIxaC01di01aC01di01aC01di01aC01IiAvPgogIDxwYXRoIGQ9Ik0xOCAzdjciIC8+CiAgPHBhdGggZD0iTTE1IDdsMyAzbDMgLTMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/stairs-down
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconStairsDown = createReactComponent('outline', 'stairs-down', 'StairsDown', __iconNode);

export default IconStairsDown;